// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if (!('title' in value)) {
				errors.push({ path: 'value["title"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["title"] !== 'string') errors.push({ path: 'value["title"]', expected: 'string', value: value["title"] });
			}
			if (!('description' in value)) {
				errors.push({ path: 'value["description"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["description"] !== 'string') errors.push({ path: 'value["description"]', expected: 'string', value: value["description"] });
			}
			if (!('scopes' in value)) {
				errors.push({ path: 'value["scopes"]', expected: '(object | object)[]', value: undefined });
			} else {
				if (!Array.isArray(value["scopes"])) errors.push({ path: 'value["scopes"]', expected: 'array', value: value["scopes"] });if (Array.isArray(value["scopes"])) { value["scopes"].forEach((element, index) => { 
    {
        let element_valid = false;
        
        if (!element_valid) {
            const element_errors_0 = [];
            
	if (typeof element !== 'object' || element === null || Array.isArray(element)) {
        element_errors_0.push({ path: 'element', expected: 'object', value: element });
    } else {
			if (!('name' in element)) {
				element_errors_0.push({ path: 'element["name"]', expected: '"jira/backlog"', value: undefined });
			} else {
				if (element["name"] !== "jira/backlog") element_errors_0.push({ path: 'element["name"]', expected: "jira/backlog", value: element["name"] });
			}
    }
            if (element_errors_0.length === 0) {
                element_valid = true;
            }
        }

        if (!element_valid) {
            const element_errors_1 = [];
            
	if (typeof element !== 'object' || element === null || Array.isArray(element)) {
        element_errors_1.push({ path: 'element', expected: 'object', value: element });
    } else {
			if (!('name' in element)) {
				element_errors_1.push({ path: 'element["name"]', expected: '"jira/board"', value: undefined });
			} else {
				if (element["name"] !== "jira/board") element_errors_1.push({ path: 'element["name"]', expected: "jira/board", value: element["name"] });
			}
    }
            if (element_errors_1.length === 0) {
                element_valid = true;
            }
        }
        if (!element_valid) {
            errors.push({ path: 'element', expected: 'object | object', value: element });
        }
    } }); }
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
